import { Component, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatStepper } from "@angular/material/stepper";

import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";

import { updateValueAndValidity } from "@dffedb/forms";
import { resetDate } from "@dffedb/util";

import { FeatureMaalerAflaesningViewModel } from "./model/feature-maaler-aflaesning.view-model";
import { FeatureMaalerAflaesningService } from "./shared/feature-maaler-aflaesning.service";

@Component({
    styleUrls: ["./feature-maaler-aflaesning.component.scss"],
    templateUrl: "./feature-maaler-aflaesning.component.html",
    host: { class: "page-width-sm" }
})
export class FeatureMaalerAflaesningComponent implements OnInit {
    public formGroup$: Observable<UntypedFormGroup>;
    public vm$: Observable<FeatureMaalerAflaesningViewModel>;
    public minDate = resetDate(new Date());
    public udfoerer = false;
    public udfoert = false;
    public udfoerError: any;
    public step = 0;
    public gemmerAflaesning: boolean;
    public senderKvittering: boolean;
    public gemAflaesningError: any;
    public sendKvitteringError: any;
    public formGroupErrors: { label: string; error: string; inputId: string }[] = [];

    @ViewChild(MatStepper)
    public stepper: MatStepper;

    constructor(private readonly service: FeatureMaalerAflaesningService) {}

    public ngOnInit(): void {
        this.vm$ = this.service.hentData().pipe(shareReplay(1));
    }

    public isValid(formGroup: UntypedFormGroup, ...formControlNames: string[]): boolean {
        return formControlNames.every((name) => formGroup.get(name).valid);
    }

    public onNext(formGroup: UntypedFormGroup): void {
        this.stepper.selected.interacted = true;
        updateValueAndValidity(formGroup);
        this.stepper.next();
        this.editEnergiField();
    }

    public async onGemAflaesning(formGroup: UntypedFormGroup): Promise<void> {
        this.stepper.selected.interacted = true;
        updateValueAndValidity(formGroup);
        if (!formGroup.valid) {
            setTimeout(() => {
                this.formGroupErrors = this.getErrors();
                document.scrollingElement.scrollTop = 0;
            }, 250);
            return;
        }
        this.gemmerAflaesning = true;
        try {
            await this.service.gemMaalerAflaesning(formGroup);
            this.gemmerAflaesning = false;
            this.step = this.step + 1;
        } catch (error) {
            this.gemmerAflaesning = false;
            this.gemAflaesningError = error;
            throw error;
        }
    }

    public async onSendKvittering(formGroup: UntypedFormGroup): Promise<void> {
        updateValueAndValidity(formGroup);
        if (!formGroup.valid) {
            setTimeout(() => {
                this.formGroupErrors = this.getErrors();
                document.scrollingElement.scrollTop = 0;
            }, 250);
            return;
        }
        this.senderKvittering = true;
        try {
            await this.service.sendMailKvittering(formGroup);
            this.senderKvittering = false;
            this.step = this.step + 1;
        } catch (error) {
            this.senderKvittering = false;
            this.sendKvitteringError = error;
            throw error;
        }
    }

    public isValidEmail(formControl: UntypedFormControl): boolean {
        return !!formControl.value && formControl.valid;
    }

    public getErrors() {
        const formFields = document.querySelectorAll("mat-form-field.mat-form-field-invalid");
        const errors: { label: string; error: string; inputId: string }[] = [];

        formFields.forEach((field) => {
            const label = field.querySelector(".mat-form-field-label").textContent.replace("*", "-");
            const error = field.querySelector(".mat-error").textContent;
            const inputId = field.querySelector("input").id;
            errors.push({ label, error, inputId });
        });

        return errors;
    }

    public navigationToError(id: string) {
        if (!id) return;
        const element = document.getElementById(id);
        element.focus();
        element.scrollIntoView({ behavior: "smooth" });
    }

    public editEnergiField() {
        document.querySelectorAll("maaler-aflaesning mat-form-field").forEach((matFormField: any) => {
            const labelElement: HTMLLabelElement = matFormField.querySelector("mat-label");
            if (labelElement && labelElement.textContent.trim() === "Energi" && labelElement.textContent.trim() !== "Energi målt i") {
                const suffixElement: HTMLElement = matFormField.querySelector(".mat-form-field-suffix");
                if (suffixElement) {
                    const spanElement = document.createElement("span");
                    spanElement.className = "sr-only";
                    spanElement.textContent = ` målt i ${suffixElement.textContent.trim()}`;
                    labelElement.appendChild(spanElement);
                }
            }
        });
    }
}
